module.exports = __webpack_public_path__ + "static/media/4.b3c7f3ec.jpg";